import { render } from "./ProjectsGridCopy.vue?vue&type=template&id=51cd9449"
import script from "./ProjectsGridCopy.vue?vue&type=script&lang=js"
export * from "./ProjectsGridCopy.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/Arham_portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__